import { __awaiter, __generator, __read, __spreadArray } from "tslib";
import { fetchCapabilities } from '@office-start/capabilities-service';
import { fetchFeatureGates } from '@office-start/feature-gates-service';
import { getHarmonyAppDefinition } from '@office-start/mos-app-utilities';
import { fetchUserEntitlements } from '@office-start/user-entitlements-service';
import { candidateMOS3AppEntries, PreinstalledAppNames, } from '../constants/preinstalledApps';
export var fetchPreinstalledApps = function () { return __awaiter(void 0, void 0, void 0, function () {
    var capabilities, featureGates, userEntitlements;
    var _a, _b, _c;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0: return [4 /*yield*/, fetchCapabilities()];
            case 1:
                capabilities = _d.sent();
                return [4 /*yield*/, fetchFeatureGates().catch(function () { return undefined; })];
            case 2:
                featureGates = (_a = (_d.sent())) === null || _a === void 0 ? void 0 : _a.result;
                return [4 /*yield*/, fetchUserEntitlements().catch(function () { return undefined; })];
            case 3:
                userEntitlements = (_c = (_b = (_d.sent())) === null || _b === void 0 ? void 0 : _b.result) !== null && _c !== void 0 ? _c : undefined;
                if (!capabilities) {
                    throw new Error('Capabilities not found');
                }
                return [2 /*return*/, __spreadArray([], __read(getPreinstalledApps(capabilities, featureGates, userEntitlements)), false)];
        }
    });
}); };
var shouldInstall = function (capabilitiesConfig, appEnumName, featureGates, userEntitlements) {
    var _a, _b, _c, _d, _e;
    switch (appEnumName) {
        case PreinstalledAppNames.Park:
            return capabilitiesConfig.parkEnabled;
        case PreinstalledAppNames.SpfxTestApp:
        case PreinstalledAppNames.Test:
            return capabilitiesConfig.m365TestAppEnabled;
        case PreinstalledAppNames.Todo:
            return capabilitiesConfig.toDoM365AppEnabled;
        case PreinstalledAppNames.Store:
            return capabilitiesConfig.storeAppEnabled;
        case PreinstalledAppNames.Yammer:
            return capabilitiesConfig.yammerM365AppEnabled;
        case PreinstalledAppNames.ImmersiveBizchat:
            var isInternalAllowlistedUser = (_a = featureGates === null || featureGates === void 0 ? void 0 : featureGates.immersiveBizchatM365AppGates) === null || _a === void 0 ? void 0 : _a.immersiveBizchatM365AppEnabled;
            var isLicensedUser = ((_b = featureGates === null || featureGates === void 0 ? void 0 : featureGates.immersiveBizchatM365AppGates) === null || _b === void 0 ? void 0 : _b.immersiveBizchatM365AppEnabledWithLicense) &&
                (userEntitlements === null || userEntitlements === void 0 ? void 0 : userEntitlements.HasCopilotBusinessChat);
            // isExternalLicensedUser will be deprecated soon
            var isExternalLicensedUser = ((_c = featureGates === null || featureGates === void 0 ? void 0 : featureGates.immersiveBizchatM365AppGates) === null || _c === void 0 ? void 0 : _c.immersiveBizchatM365AppMochaEnabled) &&
                (userEntitlements === null || userEntitlements === void 0 ? void 0 : userEntitlements.HasCopilotBusinessChat);
            return (isInternalAllowlistedUser ||
                isLicensedUser ||
                isExternalLicensedUser);
        case PreinstalledAppNames.OneDrive:
            return ((_e = (_d = featureGates === null || featureGates === void 0 ? void 0 : featureGates.oneDriveMosAppGates) === null || _d === void 0 ? void 0 : _d.oneDriveMosAppEnabled) !== null && _e !== void 0 ? _e : false);
        default:
            return false;
    }
};
var getPreinstalledApps = function (capabilitiesConfig, featureGates, userEntitlements) {
    var appDefinitions = [];
    candidateMOS3AppEntries.forEach(function (appEntry) {
        if (shouldInstall(capabilitiesConfig, appEntry.appEnumName, featureGates, userEntitlements)) {
            var harmonyApp = getHarmonyAppDefinition(appEntry.definition);
            harmonyApp && appDefinitions.push(harmonyApp);
        }
    });
    return appDefinitions;
};
//# sourceMappingURL=fetchPreinstalledApps.js.map